<script>
export default {
  mounted() {
    this.setEventListener()
    // this.loadData()
    // this.init()
    // this.readScoPath()
  },  
  data() {
    return {
      scoPath: null,
      initialState: {
        // "suspend_data":"2E746070ji1001112a0101201112G320010v_player.6oMtDiCqITU.69iu71CPzEs1^1^00~2t6~2z173sV12103Ju1~29134003440v72020118RevisadoeRevisado_Hoverg240101^8_default34203420342034000061511110~2I473ji321034Z2~2E3340034003400g600101^8_defaultp7y010108Revisado8Revisado344034203420342034203420340034003400i70000101^8Normal 2340034003400i70000101^8Normal 2340034003400g600101^8_default340034003400i70000101^8Normal 2340034003400i70000101^8Normal 2ED10w340034003000300030003000300030002100210611111100000000","core.exit":"suspend","core.session_time":"0000%3A01%3A00.0","core.lesson_status":"incomplete"
      },
      initSco: false,
    }
  },
  methods: {
    init() {
      this.initSco = true
    },

    loadData (payload) {
      console.log('!!!!!loadData!!!', JSON.stringify(payload))
      let keys = Object.keys(payload); // claves = ["nombre", "color", "macho", "edad"]
      
      for(let i=0; i< keys.length; i++){
        let key = keys[i];
        if(key != "points") {
            let newKey = key.replace('cmi.', '')
            this.initialState[newKey] = decodeURIComponent(payload[key])
        }
      }
      this.readScoPath()
      this.init()
    },

    setEventListener() {
      var eventMethod = window.addEventListener
			? "addEventListener"
			: "attachEvent";
      var eventer = window[eventMethod];
      var messageEvent = eventMethod === "attachEvent"
        ? "onmessage"
        : "message";
      let vm = this
      eventer(messageEvent, function (event) {
        console.log('setEventListener: ', messageEvent, event)
        if(event.data.type == "function") {
            if(Object.hasOwnProperty.call(event.data, 'payload')) {
              vm[event.data.name](event.data.payload)
            } else {
              vm[event.data.name]()
            }
        }
      });
    },

    readScoPath() {
      let params = new URLSearchParams(window.location.search)
      this.scoPath = params.get('scorm')
      console.info('readScoPath: ' + this.scoPath)
    },

    postMessage(scorm = true, name, value) {
      if (typeof window.parent === 'object' && window.parent !== window) {
        console.info('postMessage: ', name, value)
        let parent = window.parent;
        parent.postMessage({scorm: scorm, name: name, value: encodeURIComponent(value)}, '*')
      }
    },    

    setValue(name, value) {
      console.info('setValue: ', name, value)
      this.postMessage(true, name, value)
    }, 

    initialize() {
      setTimeout(() => {
        console.log('INICIO SCO!!!!!!')
        let scoPlayer = this.$refs.scoPlayer
        window.scoPlayer = scoPlayer
        let $el = scoPlayer.$el
        let $iframe = $el.getElementsByTagName('iframe')[0]
        let contentFrame = $iframe.contentDocument

        let body = contentFrame.body

        let runtime = body.getElementsByTagName('iframe')[0]

        let runtimeContentFrame = runtime.contentDocument

        let runtimeBody = runtimeContentFrame.body
        let vm = this
        $el.addEventListener('click', function(event) {debugger})
        runtimeBody.addEventListener('click', function(event) {
            console.info('Esperando respuesta Runtime');
            setTimeout(function() {
              try {
                let data = runtime.contentWindow.Runtime.getProgress();
                
                console.log('POINTS', data);

                if (data.hasOwnProperty('p')) {
                    if (data.p === 100) {
                      vm.postMessage(true, 'cmi.core.lesson_status', 'completed')
                    }
                    vm.postMessage(true, 'points', data.p)
                } else {
                  console.log('NO tiene puntos')
                }
              } catch (error) {
                console.warn('Falla al leer progreso sco: ' +  error.message)
              }
            }, 1000);
        });
      }, 5000)
    
    },

    getDiagnostic(name, value) {
      console.log('getDiagnostic: ', name, value)
    },

    getErrorString(name, value) {
      console.log('getErrorString: ', name, value)
    },

    getLastError(name, value) {
      console.log('getLastError:', name, value)
    },
  }
}
</script>
<template>
  <div id="app" v-if="scoPath && initSco">
    <vue-scorm-player  class="sco__player" ref="scoPlayer"
      :path="scoPath"
      :student-data="initialState"
      @get-diagnostic="getDiagnostic"
      @get-error-string="getErrorString"
      @get-last-error="getLastError"
      @initialize="initialize"
      @set-value="setValue"
    ></vue-scorm-player>
  </div>
</template>

<style lang="scss">
.sco__player{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  & > iframe{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
